//导航
<template>
  <div>
    <!-- 导航 -->
    <div class="nav">
      <div class="nav-text">Human Brain Consortium</div>
      <div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#FF7474"
          text-color="#fff"
          active-text-color="#fff"
        >
          <template v-for="(item,index) in list">
            <el-menu-item
              v-if="item.son_child.length==0"
              :route="item.vue_router"
              :index="item.vue_router"
            >
              {{item.title}}
            </el-menu-item>
            <el-submenu
              v-else
              :index="item.vue_router"
            >
              <template slot="title">{{item.title}}</template>
              <el-menu-item
                v-for="(item2,index2) in item.son_child"
                :route="item2.vue_router"
                :index="item2.vue_router"
              >
                <a
                  class="menu-item-a"
                  v-if="item2.jump_url"
                  :href="item2.jump_url"
                >{{item2.title}}
                </a>
                <div v-else>{{item2.title}}</div>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div>
        <div class="language">
          <el-select
            v-model="value"
            placeholder="请选择"
            @change='change'
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!-- 导航 -->
  </div>
</template>  
<script>
export default {
  name: 'navMenu',
  data () {
    return {
      activeIndex: '/homeContents',
      options: [{
        value: 'zh-cn',
        label: '中文'
      }, {
        value: 'en',
        label: 'English'
      }],
      list: [],
      value: 'zh-cn'
    };
  },
  // watch: {
  //   $route: {
  //     handler: function (to, from) {
  //     },
  //     深度观察监听   
  //     deep: true,
  //     immediate: true
  //   }  
  // }, 
  created () {
    //进入页面语言 
    if (localStorage.getItem('Language') != null && localStorage.getItem('Language') != '' && localStorage.getItem('Language') != undefined) {
      this.$i18n.locale = localStorage.getItem('Language') //切换中英文
      this.value = localStorage.getItem('Language')//切换中英文  
    } else {
      localStorage.setItem('Language', 'zh-cn'); // 存入一个值   
    }
    this.getNav()
    localStorage.setItem('imgURL', ''); //存入图片前缀   
  },
  methods: {
    //导航 
    async getNav () {
      const { data: data } = await this.$http.get('category', {
        params: {
          lang: localStorage.getItem('Language')
        }
      })
      this.list = data.data
    },
    //切换路由
    handleSelect (key, keyPath) {
      this.$router.push(key)
    },
    //切换中英文
    change (e) {
      if (e == 'zh-cn') {
        this.$i18n.locale = 'zh-cn'
      } else {
        this.$i18n.locale = 'en'
      }
      localStorage.setItem('Language', this.$i18n.locale); // 存入一个值  
      location.reload()
    },
  }
}
</script>  

<style lang="less" scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ff7474;
  padding: 0 310px 0 90px;
  .nav-text {
    width: 425px;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
  }

  .language {
    width: 100px;
    /deep/.el-input__inner {
      background-color: #ff7474;
      color: #fff;
    }
    /deep/ .el-select .el-input .el-select__caret {
      color: #fff;
    }
  }
}

//a标签
.menu-item-a {
  color: #fff;
  text-decoration: none;
}

/deep/.el-menu-item {
  padding: 0 35px;
  font-size: 16px;
}
// 浮动
/deep/.el-submenu__title:hover {
  background: rgba(3, 17, 26, 0.5) !important;
}

/deep/.el-submenu__title {
  // background-color: #000 !important;
}
/deep/.el-menu-item:hover {
  outline: 0;
  background-color: rgba(3, 17, 26, 0.5) !important;
}
/deep/.el-submenu__title i {
  color: #fff;
}

// 选中
.el-menu-item.is-active {
  background-color: #000 !important;
}
/deep/.el-menu.el-menu--horizontal {
  border-bottom: none;
}
//字体大小
/deep/ .el-submenu__title {
  font-size: 16px !important;
}
</style>     
 